<template>
  <div class="plan" :id="com">
    <van-nav-bar
      class="navBar"
      safe-area-inset-top
      left-arrow
      @click-left="router.go(-1)"
      v-if="!_com"
    >
    </van-nav-bar>
    <img class="jsimg" src="@/assets/img/jc.png" alt="" />
    <div class="123132" v-if="data">
      <jiuqiwusanyi v-if="com == 'jiuqiwusanyi'" :data="data[com]" />
      <danShuang v-if="com == 'danShuang'" :data="data[com]" />
      <code24 v-if="com == 'code24'" :data="data[com]" />
      <wuweibizhong v-if="com == 'wuweibizhong'" :data="data[com]" />
      <daXiaoShu v-if="com == 'daXiaoShu'" :data="data[com]" />
      <tou v-if="com == 'tou'" :data="data[com]" />
      <liumashierxiao v-if="com == 'liumashierxiao'" :data="data[com]" />
      <heshudanshuang v-if="com == 'heshudanshuang'" :data="data[com]" />
      <jiaqingyeshou v-if="com == 'jiaqingyeshou'" :data="data[com]" />
      <zuoyouxiao v-if="com == 'zuoyouxiao'" :data="data[com]" />
      <sanXiao v-if="com == 'sanXiao'" :data="data[com]" />
      <qianHou v-if="com == 'qianHou'" :data="data[com]" />
      <pingtesanxiao v-if="com == 'pingtesanxiao'" :data="data[com]" />
      <wenzhuan2bo v-if="com == 'wenzhuan2bo'" :data="data[com]" />
      <neimushierma v-if="com == 'neimushierma'" :data="data[com]" />
      <biaozhunqiwei v-if="com == 'biaozhunqiwei'" :data="data[com]" />
      <shujinguangsanxiao v-if="com == 'shujinguangsanxiao'" :data="data[com]" />
      <riyexiao v-if="com == 'riyexiao'" :data="data[com]" />
      <dandaxiaoxiao v-if="com == 'dandaxiaoxiao'" :data="data[com]" />
      <pingtewuma v-if="com == 'pingtewuma'" :data="data[com]" />
    </div>
    <!-- 
    <sanxiao :data="data.sanXiao" v-if="data?.sanXiao" />
    <dujia :data="data.dujiachang" v-if="data?.dujiachang" />
    <liuxiao :data="data.qiXiao" v-if="data?.qiXiao" />
    <tou :data="data.tou" v-if="data?.tou" />
    <bose :data="data.boSe" v-if="data?.boSe" />
    <code24 :data="data.code24" v-if="data?.code24" />
    <wei :data="data.wei" v-if="data?.wei" />
    <chunxiaqiudong :data="data.cxqd" v-if="data?.cxqd" />
    <wuXingZhongTe :data="data.wuXingZhongTe" v-if="data?.wuXingZhongTe" />
    <qianhou :data="data.qianHou" v-if="data?.qianHou" />
    <danshuang :data="data.danShuang" v-if="data?.danShuang" />
    <yixiao :data="data.yiXiao" v-if="data?.yiXiao" />
    <daXiao :data="data.daXiaoShu" v-if="data?.daXiaoShu" />
    <danshuang4xiao :data="data.danshuang4xiao" v-if="data?.danshuang4xiao" />
    <heshudanshuang :data="data.heshudanshuang" v-if="data?.heshudanshuang" />
    <pingtesanxiao :data="data.pingtesanxiao" v-if="data?.pingtesanxiao" />
    <jingzhun20ma :data="data.jingzhun20ma" v-if="data?.jingzhun20ma" />
    <wenzhuan2bo :data="data.wenzhuan2bo" v-if="data?.wenzhuan2bo" />
    <neimuertou :data="data.neimu2tou" v-if="data?.neimu2tou" />
    <biaozhun7wei :data="data.biaozhun7wei" v-if="data?.biaozhun7wei" />
    <wensha2xiao :data="data.wensha2xiao" v-if="data?.wensha2xiao" />
    <sixiaobama
      :data="data.miezhuangsixiaobama"
      v-if="data?.miezhuangsixiaobama"
    />
    <jiaqingyeshou :data="data.jiaqingyeshou" v-if="data?.jiaqingyeshou" />
    <daxiaozhongte :data="data.daxiaozhongte" v-if="data?.daxiaozhongte" />
    <bizhongdanshuang
      :data="data.bizhongdanshuang"
      v-if="data?.bizhongdanshuang"
    /> -->
  </div>
</template>

<script setup>
import { myHttp } from "@/request/index.js";
import { defineAsyncComponent, ref } from "vue";
// import liuxiao from "./liuxiao.vue";
// import bose from "./bose.vue";
// import wei from "./wei.vue";
// import yixiao from "./yixiao.vue";
// import sanxiao from "./sanxiao.vue";
// import daXiao from "./daXiaoShu.vue";
// import wuXingZhongTe from "./wuXingZhongTe.vue";
// import chunxiaqiudong from "./chunxiaqiudong.vue";
// import dujia from "./dujia.vue";
// import bizhongdanshuang from "./bizhongdanshuang.vue";
// import danshuang4xiao from "./danshuang4xiao.vue";
// import daxiaozhongte from "./daxiaozhongte.vue";
// import jingzhun20ma from "./jingzhun20ma.vue";
// import sixiaobama from "./sixiaobama.vue";
// import neimuertou from "./neimuertou.vue";
// import wensha2xiao from "./wensha2xiao.vue";
// import biaozhun7wei from "./biaozhun7wei.vue";
import { useRoute, useRouter } from "vue-router";
//
import jiuqiwusanyi from "./jiuqiwusanyi.vue";
import danShuang from "./danShuang.vue";
import code24 from "./code24.vue";
import wuweibizhong from "./wuweibizhong.vue";
import daXiaoShu from "./daXiaoShu.vue";
import tou from "./tou.vue";
import liumashierxiao from "./liumashierxiao.vue";
import heshudanshuang from "./heshudanshuang.vue";
import jiaqingyeshou from "./jiaqingyeshou.vue";
import zuoyouxiao from "./zuoyouxiao.vue";
import sanXiao from "./sanXiao.vue";
import qianHou from "./qianHou.vue";
import pingtesanxiao from "./pingtesanxiao.vue";
import wenzhuan2bo from "./wenzhuan2bo.vue";
import neimushierma from "./neimushierma.vue";
import shujinguangsanxiao from "./shujinguangsanxiao.vue";
import biaozhunqiwei from "./biaozhunqiwei.vue";
import riyexiao from "./riyexiao.vue";
import dandaxiaoxiao from "./dandaxiaoxiao.vue";
import pingtewuma from "./pingtewuma.vue";
const route = useRoute();

const props = defineProps({
  _com: {
    type: String,
    required: "",
  },
});

const com = props._com || route.query.com;
// const com = "danshuang4xiao";

const router = useRouter();

const data = ref(null);

function loadData() {
  myHttp.get("/api/information/queryAll_6").then((res) => {
    if (res.success) {
      data.value = res.data;
      console.log({ ...data.value });
    }
  });
}

loadData();
</script>

<style lang="scss" scoped>
.title {
  background: linear-gradient(to right, #9ea9c6, #c4d0e1, #92a0be);
  font-size: 20px;
}
.jsimg {
  width: 100%;
}
::v-deep .plan_item {
  .plan_item_title {
    background-image: none;
    background: linear-gradient(to right, #a3aeca, #fff, #9ea9c5);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  ul {
    li {
      // background: linear-gradient(to bottom, #e893f9, #ab79e4) !important;
      padding: 12px 0;
      background-color: #555;
      font-weight: 600;
      .name,
      .qi {
        color: #ccc !important;
      }
    }
  }
}
.plan {
  .title {
    text-align: center;
    // background-color: #009788;
    font-size: 25px;
    font-weight: bold;
    padding: 6px 0;
  }
  .plan_item {
    border: 1px solid #009788;
    .plan_item_advertisement {
      img {
        width: 100%;
        height: 40px;
        display: block;
      }
    }
    .plan_item_title {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      font-weight: bold;
      text-align: center;
      // background-image: linear-gradient(to bottom, #e893f9, #ab79e4) !important;
      padding: 3px 0;
      border-top: 2px solid #767474;
      border-bottom: 2px solid #767474;
      color: #000 !important;
      span {
        color: #000 !important;
      }
      img {
        width: 30px;
        height: 30px;
      }
    }
    ul {
      background-color: #eee;
      li {
        text-align: center;
        padding: 5px 12px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        .value {
          color: red;
          .win {
            background-color: #ffff00;
          }
        }
        &:not(:last-child) {
          border-bottom: 2px solid #d2d2d2;
        }
      }
      .li_win {
        .winText {
          color: #d00880;
        }
      }
      .suck {
        text-decoration-line: line-through;
      }
    }
  }

  .TK118 {
    width: 100%;
    height: 70px;
  }
}
</style>